import styled from "@emotion/styled";
import {
  BackgroundImageAnchor,
  BackgroundImageAttachment,
} from "@/constants/media";
import { useImgixImageURL } from "@/hooks/useImgixImageURL";
import type { BaseSiteBuilderModule } from "@/types/site-builder";

type ImageSettings = BaseSiteBuilderModule["style"]["background"]["image"];

interface BGProps extends Pick<ImageSettings, "attachment" | "zoom"> {
  src: string;
  positionX: string;
}

const BG = styled.div<BGProps>`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: ${({ src, positionX }) =>
    `url(${src}) no-repeat scroll ${positionX} center / cover`};

  @media (min-width: 768px) {
    background-size: ${({ zoom }) => (zoom === 0 ? "cover" : `${zoom + 100}%`)};
    background-attachment: ${({ attachment }) =>
      attachment === BackgroundImageAttachment.Fixed ? "fixed" : "scroll"};
  }
`;

export interface BackgroundImageProps {
  settings: ImageSettings;
}

export default function BackgroundImage({ settings }: BackgroundImageProps) {
  const { image, attachment, anchor, shiftX, zoom } = settings;

  const imageURI = useImgixImageURL(image?.source?.path);
  if (!imageURI) return null;

  let positionX;
  switch (anchor) {
    case BackgroundImageAnchor.Left:
      positionX = `left ${shiftX}%`;
      break;

    case BackgroundImageAnchor.Right:
      positionX = `right ${shiftX}%`;
      break;

    default:
      positionX = "center";
  }

  return (
    <BG
      src={imageURI}
      zoom={zoom}
      positionX={positionX}
      attachment={attachment}
    />
  );
}
